const React = require('react')

const toolsOptions = [
    {
        name: 'Verify Contract',
        value: 'verifyContract'
    },
    {
        name: 'Similar Contracts',
        value: 'find-similar-contracts'
    }
]

module.exports = { toolsOptions }
